export default class Filters {
  constructor(filterControl) {
    this.filterControl = filterControl;
    this.filterControlWrapper = filterControl.querySelector(`.js-filters-controls-wrapper`);

    this.filterControlButtons = filterControl.querySelector(`.js-filters-controls-buttons`);
    this.filterControlButtonsLinks = this.filterControlButtons.querySelectorAll(`.filters__link`);
    this.filterControlButtonsLinkActive = this.filterControlButtons.querySelector(`.filters__link--active`);

    this.filterControlSelect = filterControl.querySelector(`.js-filters-controls-select`);
    if(this.filterControlSelect) {
      this.filterControlSelectLinks = this.filterControlSelect.querySelector(`a`);
    }

    this.filterCards = document.querySelectorAll(`.js-filters-cards`);

    this.filterGetParams = this._GET('filter');

    this._filterControlsButtonsClickHandler = this._filterControlsButtonsClickHandler.bind(this);
    this._filterControlsSelectClickHandler = this._filterControlsSelectClickHandler.bind(this);
    this._filterControlsSelectLindClickHandler = this._filterControlsSelectLindClickHandler.bind(this);

    this.init();
  }

  _GET(key) {
    let filterButtonsList = "(active-products)|(top3)|(aggressive)|(balance)|(deposite-alternate)|(currency)";
    //если переход по GET параметру
    let s = window.location.search;
    //если переход на ресурс
    let x = window.location.pathname;
    x = x.match(new RegExp(filterButtonsList));

    if (x) {
      return x[0];
    }
    s = s.match(new RegExp(key + '=([^&=]+)'));
    return s ? s[1] : false;
  }

  _changeFilterSelect(elem) {
    if (elem && this.filterControlSelectLinks) {
      this.filterControlSelectLinks.childNodes[0].textContent = elem.textContent;
      this.filterControlButtonsLinkActive.classList.remove(`filters__link--active`);
      elem.classList.add(`filters__link--active`);
      this.filterControlWrapper.classList.remove(`active`);
      this._changeFilterButtons(elem);
    }
  }

  _changeFilterButtons(elem) {
    this.filterControlButtonsLinkActive.classList.remove(`filters__link--active`);
    this.filterControlButtonsLinkActive = elem;
    elem.classList.add(`filters__link--active`);
    let filterCategory = elem.innerHTML;
    if (this.filterCards.length) {
      this.filterCards.forEach((filterCard, i) => {
        const cards = filterCard.querySelectorAll('[data-filter]');
        if (cards.length) {
          cards.forEach((cards, i) => {
            if (cards.classList.contains('no-filter') == false) {
              if (
                elem.classList.contains('filters__link--show_all')
                || cards.getAttribute('data-filter').indexOf(filterCategory) != -1
              ) {
                cards.classList.remove('hidden_element');
              } else {
                cards.classList.add('hidden_element');
              }
            }
          });
        }
        const count =  filterCard.querySelectorAll('[data-filter]:not(.hidden_element)').length;
        if(filterCard.querySelector('.js-amount__text')) {
          if(filterCard.querySelector('.js-amount__text').classList.contains('js-only-new')) {
            filterCard.querySelector('.js-amount__text').textContent = count.toString();
          }
          else {
            filterCard.querySelector('.js-amount__text').textContent = (count/2).toString();
          }
        }
        filterCard.setAttribute('style',  count ? 'display:block' : 'display:none !important');
      });
    }
  }

  _filterControlsSelectLindClickHandler(evt) {
    this._changeFilterSelect(evt.target.closest(`.filters__link`));
  }

  _filterControlsSelectClickHandler() {
    this.filterControlWrapper.classList.toggle(`active`);
    if (this.filterControlSelect) {
      document.documentElement.style.setProperty(
        `--filters-active-height`,
        `${this.filterControlSelect.scrollHeight - 2}px`
      );
    }
  }

  _filterControlsButtonsClickHandler(eventTarget) {
    this._changeFilterButtons(eventTarget.currentTarget);
  }

  init() {
    //Сейчас по умолчанию выводятся фильтрованные данные
    this.defaultFilter = document.querySelector('.js-default-filter');
    if (this.defaultFilter) {
      this._changeFilterButtons(this.defaultFilter);
      this._changeFilterSelect(this.defaultFilter);
    }

    if(this.filterGetParams && this.filterControlButtonsLinks.length) {
      let fun_name = decodeURI(this.filterGetParams);

      switch (fun_name) {
        case 'active-products':
          fun_name = "Все активные продукты"
          break;
        case 'top3':
          fun_name = "ТОП - 3 фонда"
          break;
        case 'target-date-funds':
          fun_name = "Фонды с целевой датой"
          break;
        case 'aggressive':
          fun_name = "Агрессивная стратегия"
          break;
        case 'balance':
          fun_name = "Сбалансированные фонды"
          break;
        case 'deposite-alternate':
          fun_name = "Альтернатива депозиту"
          break;
        case 'currency':
          fun_name = "Валютные фонды"
          break;
        case 'classic-funds':
          fun_name = "Классические фонды"
          break;
      }

      this.filterControlButtonsLinks.forEach((link, i) => {
        if(link.innerHTML == fun_name) {
          let _this = this;
          setTimeout(function () {
            _this._changeFilterButtons(link);
            _this._changeFilterSelect(link);
          });
          return;
        }
      });
    }

    // обработка нажатия на кнопки фильтра
    if (this.filterControlButtonsLinks.length) {
      this.filterControlButtonsLinks.forEach((link, i) => {
        link.addEventListener(`click`, this._filterControlsButtonsClickHandler);
      });
    }

    // открытие select
    if (this.filterControlSelectLinks) {
      this.filterControlSelectLinks.addEventListener(`click`, this._filterControlsSelectClickHandler);
    }
    // выбор и закрытие select
    if (this.filterControlButtons) {
      this.filterControlButtons.addEventListener(`click`, this._filterControlsSelectLindClickHandler);
    }

    // замена текста основного селекта для наблюдения за выводом конкретной страницы
    if (this.filterControlSelectLinks) {
      this.filterControlSelectLinks.childNodes[0].textContent = this.filterControlButtonsLinkActive.childNodes[0].textContent;
    }
  }
}